import styled from 'styled-components'
import {
  FONT_SIZE,
  COLOR,
  Z_INDEXS,
} from '../../themes'
const shadow = `0px 3px 6px 0px ${COLOR.GRAY_5}`
export const DropDownStyle = styled.div`
  position: relative;
  font-size: ${FONT_SIZE.TN};

  .div-select-list{
    z-index: ${Z_INDEXS.LV_3};
    color: ${COLOR.BLACK_1};
    display: block;
    position: absolute;
    background: ${COLOR.WHITE};
    overflow: auto;
    text-align: left;
    box-shadow: ${shadow};
    border-radius: 4px;
  }

  .list-search{
    border-bottom: 1px solid ${COLOR.GRAY_2};
    padding: 10px 10px 10px 16px;
  }

  .list-search:hover {
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }

  .disabled-select{
    color: ${COLOR.GRAY_8};
    cursor: not-allowed;
  }

  .div-dropDown{
    background: ${COLOR.WHITE};
    line-height: 40px;
    color: ${COLOR.BLACK_1};
    padding: 0px 16px 0px 16px;
    cursor: pointer;
    box-shadow: ${shadow};
  }

  .text-select{
    color: ${COLOR.BLACK_1};
  }

  .sort-up{
    transform: rotate(180deg);
  }

  .dropDown-error{
    border: 1px solid ${COLOR.RED_1};
    color: ${COLOR.RED_2}; 

  }

  .sort{
   float: right
  }

  .disabled{
    background-color: ${COLOR.GRAY_2} !important;
    cursor: not-allowed !important;
  }
`
